export default "__VITE_ASSET__CUBWxprC__"